import { Tab, Tabs } from "@material-ui/core";
import { useSelector } from "react-redux";
export default function SearchTabs(props) {
  const { tabValue, setTabValue, numberOfBond, numberOfETF, numberOfStock } =
    props;

  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  return (
    <>
      <div
        style={{
          height: isDesktopOrLaptop ? "43px" : "32px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Tabs
          value={tabValue}
          indicatorColor="primary"
          textColor="primary"
          onChange={(e, val) => {
            setTabValue(val);
          }}
          TabIndicatorProps={{
            style: {
              background: "#0040ff",
              height: "8px",
              borderRadius: "21px",
              borderBottomLeftRadius: "0px",
              borderBottomRightRadius: "0px",
            },
          }}
          centered
          inkBarStyle={{ background: "#0040f" }}
          style={{
            minHeight: isDesktopOrLaptop ? "43px" : "32px",
          }}
        >
          <Tab
            value={1}
            label={
              <span>
                <span style={{ fontWeight: "bold" }}>{numberOfStock}</span>{" "}
                {numberOfStock > 1 ? props.t("stoks") : props.t("stock")}
              </span>
            }
            style={{
              color: tabValue === 1 ? "#0040ff" : "#16063b",
              fontFamily: "Overpass",
              fontSize: isDesktopOrLaptop ? "16px" : "12px",
              margin: isDesktopOrLaptop ? "0 100px 0 0" : "0 33px 0 0",
              padding: 0,
              minWidth: "50px",
              minHeight: isDesktopOrLaptop ? "43px" : "15px",
            }}
          />

          <Tab
            value={2}
            label={
              <span>
                <span style={{ fontWeight: "bold" }}>{numberOfETF}</span> ETF
              </span>
            }
            style={{
              color: tabValue === 2 ? "#0040ff" : "#16063b",
              fontFamily: "Overpass",
              fontSize: isDesktopOrLaptop ? "16px" : "12px",
              margin: isDesktopOrLaptop ? "0 100px 0 0" : "0 33px 0 0",
              padding: 0,
              minWidth: "50px",
              minHeight: isDesktopOrLaptop ? "43px" : "15px",
            }}
          ></Tab>
          <Tab
            value={0}
            label={
              <span>
                <span style={{ fontWeight: "bold" }}>{numberOfBond}</span>{" "}
                {numberOfBond > 1 ? props.t("bonds") : props.t("bond")}
              </span>
            }
            style={{
              color: tabValue === 0 ? "#0040ff" : "#16063b",
              fontFamily: "Overpass",
              fontSize: isDesktopOrLaptop ? "16px" : "12px",
              display: "flex",
              margin: 0,
              padding: 0,
              minWidth: "50px",
              minHeight: isDesktopOrLaptop ? "43pxpx" : "15px",
            }}
          />
        </Tabs>
      </div>
    </>
  );
}
